import View from './view';

export const LinkedAccounts = View;
